<div mat-dialog-title>
  <div>Payment Schedule</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p class="line-1">
    These payments are based on the current data that is available. They are subject to change based on verification of
    forested land, the terms of your contract and/or market performance.
  </p>
  <table [dataSource]="paymentDetails" class="fc-table" mat-table aria-describedby="Payment Details">
    <ng-container matColumnDef="description">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">Description</th>
      <td *matCellDef="let element" mat-cell class="column-large">
        {{ element.description }}
      </td>
    </ng-container>
    <ng-container matColumnDef="accrualPeriod">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">Accrual Period</th>
      <td *matCellDef="let element" mat-cell class="column-large">
        {{ element.accrualPeriod }}
        @if (element.accrualDescription) {
          <div class="row-subtitle"><sup>*</sup>{{ element.accrualDescription }}</div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="generation">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">ERT Generation</th>
      <td *matCellDef="let element" mat-cell class="column-small">
        {{ element.generation }}
        @if (element.generationDescription) {
          <div class="row-subtitle"><sup>*</sup>{{ element.generationDescription }}</div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="ppt">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">Price Per Ton</th>
      <td *matCellDef="let element" mat-cell class="column-small">
        {{ element.ppt | currency: 'USD' }}
        @if (element.isVariable) {
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
                  'Variable Period: The price shown is based on the current carbon offset market rate and is subject to change.'
                "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        }
        @if (element.pptDescription) {
          <div class="row-subtitle"><sup>*</sup>{{ element.pptDescription }}</div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="paymentAmount">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">Payment</th>
      <td *matCellDef="let element" mat-cell class="column-small">
        {{ element.paymentAmount | currency: 'USD' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="totalPayments">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">Number of Payments</th>
      <td *matCellDef="let element" mat-cell class="column-small">
        {{ element.totalPayments }}
      </td>
    </ng-container>
    <ng-container matColumnDef="totalRevenue">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-medium">Total Revenue</th>
      <td *matCellDef="let element" mat-cell class="column-medium">
        {{ element.totalRevenue | currency: 'USD' }}
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>

</div>
<div mat-dialog-actions>
  <button (click)="onNoClick()" color="primary" mat-raised-button>Close</button>
</div>
